import { combineReducers } from "redux";
import settings from "./settings/reducer";
import menu from "./menu/reducer";
import auction from "./auctions/reducer";
import auth from "./auth/reducer";
import filters from "./filters/reducer";
import InfathParticipationWorkflowReducer from "./auctions/infathParticipationWorkflow/reducer";
import SellerSpecialEligibilityReducer from "./auctions/sellerSpecialEligibility/reducer";

const reducers = combineReducers({
  menu,
  settings,
  auction,
  auth,
  filters,
  InfathParticipationWorkflowReducer,
  SellerSpecialEligibilityReducer,
});

export default reducers;
